<template>
  <div class="partner-activation">
    <loader />
  </div>
</template>

<script>
import { getQueryParamsAsObject } from 'lib/utils/url';

import HTTPService from '@/services/Http';

import Loader from '@/components/otherElements/Loader';

export default {
  name: 'PartnerActivation',
  components: {
    Loader,
  },
  created() {
    this.partnerActivation();
  },
  methods: {
    partnerActivation() {
      const GET_PARAMS = [
        'merchant_id',
        'parent_merchant_id',
        'project_id',
      ];

      const rawString = window.location.search.slice(1);
      const preparedMap = getQueryParamsAsObject(decodeURIComponent(rawString));

      const filteredParams = Object.keys(preparedMap).filter((parameter) => GET_PARAMS.includes(parameter));

      const preparedParams = filteredParams.reduce((acc, curr) => {
        acc[curr] = preparedMap[curr] !== 'undefined' ? preparedMap[curr] : '';
        return acc;
      }, {});

      const requestData = {
        merchantId: preparedParams.merchant_id,
        parentMerchantId: preparedParams.parent_merchant_id,
        projectId: preparedParams.project_id,
      };

      HTTPService.partnerActivation(requestData)
        .then(() => {
          this.$alert({
            type: 'success',
            text: this.$t('common.success'),
          });
        })
        .catch(() => {
          this.$alert({
            type: 'warning',
            text: this.$t('not.success'),
          });
        })
        .finally(() => {
          this.$router.push({ name: 'cabinet' });
        });
    },
  },
};
</script>

<style lang="sass" scoped>
  .partner-activation
    width: 100%
    height: 100vh
    position: absolute
    top: 0
    right: 0
    bottom: 0
    left: 0
</style>
